import {Exhibit} from "types/Exhibit";
import {Option} from "components/Form/Select/Select";
import IconName from "types/IconName";
import {Message} from "types/Message";
import {Offer} from "types/Offer";
import {Facility} from "../types/Facility";

export const exhibitOption = (exhibit: Exhibit): Option => ({
    id: exhibit.id,
    name: exhibit.name,
    description: `${exhibit.type.name}${exhibit.zone?.site?.name ? ` (${exhibit.zone?.site?.name})` : ''}`,
    icon: IconName.LIBRARY
})

export const facilityOption = (facility: Facility): Option => ({
    id: facility.id,
    name: facility.name,
    description: `${facility.type.name}${facility.zone?.site?.name ? ` (${facility.zone?.site?.name})` : ''}`,
    icon: IconName.OFFICE_BUILDING
})

export const messageOption = (message: Message): Option => ({
    id: message.id,
    name: message.subject,
    description: message.channels.join(", "),
    icon: IconName.MAIL
})

export const offerOption = (offer: Offer): Option => ({
    id: offer.id,
    name: offer.name,
    description: (offer.has_expired ? '(expired) ' : '') + offer.incentive,
    icon: IconName.GIFT
})